document.addEventListener("DOMContentLoaded", function () {
  const dataEl = document.getElementById('PromoPopupData');
  if (!dataEl) return;

  const { settings, campaigns } = JSON.parse(dataEl.textContent || '{}');

  const popup = document.getElementById('PromoPopup');
  const overlay = popup?.querySelector('.promo-popup__overlay');
  const closeBtn = popup?.querySelector('.promo-popup__close');

  const badge = document.getElementById('PromoPopupBadge');
  const preview = document.getElementById('PromoPopupPreview');
  const previewImg = document.getElementById('PromoPopupPreviewImage');

  const imgWrap = popup?.querySelector('.promo-popup__image');
  const imgEl = imgWrap?.querySelector('img');
  const titleEl = popup?.querySelector('.promo-popup__title');
  const textEl = popup?.querySelector('.promo-popup__text');
  const noteEl = popup?.querySelector('.promo-popup__note');
  const btnEl = popup?.querySelector('.promo-popup__button');

  let activeCampaign = null;
  let scrollY = 0;

  function parseDate(d) {
    if (!d) return null;
    const dt = new Date(d + 'T00:00:00');
    return isNaN(dt.getTime()) ? null : dt;
  }

  function pickActiveCampaign() {
    const now = new Date();
    const list = (campaigns || [])
      .filter(c => c.enabled)
      .filter(c => {
        const start = parseDate(c.startAt);
        const end = parseDate(c.endAt);
        if (start && now < start) return false;
        if (end && now > end) return false;
        return true;
      })
      .sort((a, b) => (b.priority || 0) - (a.priority || 0));

    return list[0] || null;
  }

  function storageKey(c) {
    return `promoPopupSeen:${c.id}`;
  }

  function alreadySeen(c) {
    if (!c.showOnce) return false;
    try { return localStorage.getItem(storageKey(c)) === '1'; } catch { return false; }
  }

  function markSeen(c) {
    if (!c?.showOnce) return;
    try { localStorage.setItem(storageKey(c), '1'); } catch {}
  }

  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  function isAgeVerified() {
    return getCookie('ageVerification') === 'uber';
  }

  function isCookieConsentDone() {
    if (getCookie('_tracking_consent')) return true;

    const banner = document.querySelector(
      '#shopify-pc__banner, .shopify-policy-banner, [data-shopify-cookie-banner]'
    );

    return !banner || banner.offsetParent === null;
  }

  function waitForPrerequisites(callback) {
    const ready = () => isAgeVerified() && isCookieConsentDone();

    if (ready()) {
      callback();
      return;
    }

    const interval = window.setInterval(() => {
      if (!ready()) return;
      window.clearInterval(interval);
      callback();
    }, 300);

    window.setTimeout(() => {
      window.clearInterval(interval);
    }, 30000);
  }

  function lockScroll() {
    if (document.documentElement.dataset.promoPopupLocked === '1') return;

    document.documentElement.dataset.promoPopupLocked = '1';

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.marginRight = `${scrollbarWidth}px`;

    scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockScroll() {
    if (document.documentElement.dataset.promoPopupLocked !== '1') return;

    document.documentElement.dataset.promoPopupLocked = '';

    document.documentElement.style.overflow = '';
    document.documentElement.style.marginRight = '';

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';

    window.scrollTo(0, scrollY);
  }

  function showPopup() {
    popup?.classList.remove('promo-popup__hidden');
    popup?.setAttribute('aria-hidden', 'false');
    lockScroll();

    requestAnimationFrame(() => {
      popup?.classList.add('is-visible');
    });
  }

  function hidePopup() {
    if (activeCampaign) {
      markSeen(activeCampaign);
    }

    popup?.classList.remove('is-visible');
    popup?.setAttribute('aria-hidden', 'true');
    unlockScroll();

    window.setTimeout(() => {
      popup?.classList.add('promo-popup__hidden');
    }, 300);
  }

  function openPopup(c) {
    if (!popup) return;
    if (alreadySeen(c)) return;

    activeCampaign = c;

    if (titleEl) titleEl.textContent = c.title || '';
    if (textEl) textEl.innerHTML = c.text || '';
    if (noteEl) noteEl.textContent = c.note || '';

    if (imgWrap && imgEl) {
      if (c.imageUrl) {
        imgEl.src = c.imageUrl;
        imgWrap.classList.add('is-visible');
      } else {
        imgWrap.classList.remove('is-visible');
      }
    }

    if (btnEl) {
      btnEl.textContent = c.buttonLabel || '';
      btnEl.href = c.buttonUrl || '#';
      btnEl.classList.toggle('is-hidden', !c.buttonLabel || !c.buttonUrl);
    }

    showPopup();
  }

  function bindOpen(el, c) {
    if (!el) return;
    el.addEventListener('click', (e) => {
      e.preventDefault();
      openPopup(c);
    });
  }

  overlay?.addEventListener('click', hidePopup);
  closeBtn?.addEventListener('click', hidePopup);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') hidePopup();
  });

  const campaign = pickActiveCampaign();
  if (!campaign) return;
  if (alreadySeen(campaign)) return;

  const trigger = (campaign.trigger && campaign.trigger !== 'inherit')
    ? campaign.trigger
    : settings.defaultTrigger;

  const delayMs = (campaign.delayMs && campaign.delayMs > 0)
    ? campaign.delayMs
    : (settings.defaultDelayMs || 0);

  badge?.classList.add('promo-popup__hidden');
  preview?.classList.add('promo-popup__hidden');

  if (trigger === 'teaser' && campaign.teaserImageUrl && preview && previewImg) {
    previewImg.src = campaign.teaserImageUrl;
    preview.classList.remove('promo-popup__hidden');
    bindOpen(preview, campaign);
  } else if (trigger === 'badge' && badge) {
    badge.textContent = settings.badgeLabel || badge.textContent;
    badge.classList.remove('promo-popup__hidden');
    bindOpen(badge, campaign);
  }

  if (trigger === 'delay') {
    waitForPrerequisites(() => {
      window.setTimeout(() => {
        openPopup(campaign);
      }, Math.max(0, delayMs));
    });
  }
});